import React, { useState, useEffect } from 'react';

interface ScrollIndicatorProps {
  show: boolean;
}

const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({ show }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!show) {
      setIsVisible(false);
      return;
    }

    setIsVisible(true);

    const handleScroll = () => {
      // Hide indicator when user scrolls down more than 100px
      if (window.scrollY > 100) {
        setIsVisible(false);
      }
    };

    // Also hide after 30 seconds
    const timeoutId = setTimeout(() => {
      setIsVisible(false);
    }, 30000);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [show]);

  if (!show || !isVisible) {
    return null;
  }

  return (
    <div className="scroll-indicator">
      <div className="scroll-indicator-content">
        <span className="scroll-indicator-text">Scroll down for results</span>
        <div className="scroll-indicator-arrow">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10L12 15L17 10"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ScrollIndicator;

